export default "__VITE_ASSET__c0b1a656__"